import React from "react";

export const OHIO_DISCLOSURE = "This example uses our Ohio funding model. Actual funding charges and repayment terms vary by state, case details, and underwriting approval. Your final terms will be provided for review before you sign.";
export const NON_OHIO_DISCLOSURE = "Illustrative Ohio Funding Example — These figures demonstrate our Ohio pricing model and are not a quote for your selected state. Actual charges and repayment terms depend on applicable state requirements, case details and underwriting.";

export const OhioExampleDisclosure = ({ stateAbbr, className, testid }) => (
  <div className={className} data-testid={testid}>
    {stateAbbr === "OH" ? OHIO_DISCLOSURE : NON_OHIO_DISCLOSURE}
  </div>
);
